import { Collection } from '../../lib/types';
import CollectionCard from '../CollectionCard';

export interface CollectionsGridProps {
  collections?: Collection[];
  onRemoveCollection?: (collection: Collection) => void;
}

export const CollectionsGrid = ({
  collections = [],
  onRemoveCollection,
}: CollectionsGridProps) => {
  return (
    <div className="collections-grid">
      {collections.map((collection: Collection, index: number) => (
        <CollectionCard
          key={`collection-card-${collection.ref}-${index}`}
          collection={collection}
          onRemoveCollection={onRemoveCollection}
        />
      ))}
    </div>
  );
};
